import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "kubeconfig-clusters" }
const _hoisted_2 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_3 = {
  key: 1,
  class: "text-muted"
}

import { computed } from 'vue';

interface ClusterReference {
  label: string;
  location?: object;
}

const MAX_DISPLAY = 25;


export default /*@__PURE__*/_defineComponent({
  __name: 'KubeconfigClusters',
  props: {
    row: {},
    value: {}
  },
  setup(__props: any) {

const props = __props;

const allClusters = computed<ClusterReference[]>(() => {
  return props.row?.sortedReferencedClusters || [];
});

const clusters = computed<ClusterReference[]>(() => {
  return allClusters.value.slice(0, MAX_DISPLAY);
});

const remainingCount = computed<number>(() => {
  return Math.max(0, allClusters.value.length - MAX_DISPLAY);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clusters.value, (cluster, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (index > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(", ")
            ], 64))
          : _createCommentVNode("", true),
        _cache[0] || (_cache[0] = _createTextVNode()),
        (cluster.location)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: `${_ctx.row.id}-${cluster.label}`,
              to: cluster.location
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(cluster.label), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          : (_openBlock(), _createElementBlock("span", {
              key: `${_ctx.row.id}-${cluster.label}-deleted`,
              class: "text-muted"
            }, _toDisplayString(cluster.label), 1))
      ], 64))
    }), 256)),
    _cache[1] || (_cache[1] = _createTextVNode()),
    (remainingCount.value > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.t('ext.cattle.io.kubeconfig.moreClusterCount', { remainingCount: remainingCount.value })), 1))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createTextVNode()),
    (allClusters.value.length === 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "\n      —\n    "))
      : _createCommentVNode("", true)
  ]))
}
}

})